export const communitiesFeatureKey = ['communities'] as const;
